<template>
    <div class="position-r">
        <!--banner-->
        <!--<div class="index-banner">-->
            <!--<div class="f24 fw">欢迎使用</div>-->
            <!--<div class="f24 fw"><span class="color-09">陪一会</span>共享轮椅</div>-->
            <!--<div class="pt5 flex-fs">-->
                <!--<div class="mr8 photo-icon">-->
                    <!--<img :src="headPhoto" alt="" class="head-img"/>-->
                <!--</div>-->
                <!--<span>{{userName}}</span>-->
            <!--</div>-->
        <!--</div>-->

        <div class="flexJC alignItem" style="padding-top: 20%">
            <div class="flex-fs fw mb10">
                <i class="icon-con icon_lb"></i>
                <span class="f16 color-3 mt-3">{{filterFun(orderRefund&&orderRefund.placeName)}}</span>
            </div>
            <div class="mb20">
                <span class="f16 color-3 mt-3">{{filterFun(orderRefund&&orderRefund.cabinetName)}}</span>
            </div>
            <div class="icon-gh">
                <img src="../../static/images/icon_gh.png" alt="">
                <div class="giveBack-jt flexJC alignItem">
                    <img src="../../static/images/icon_jt.png" alt="" style="width: 29px;height: 61px">
                    <p class="f14 color-66">请箭头朝下放置</p>
                </div>
            </div>
            <div class="pt10">
                <p class="f20 color-3 mb10 fw" v-show="currentBed>0">已为您打开<span class="color-09">{{currentBed}}</span>号门</p>
                <h3 class="f20 color-3">请将陪护轮椅<span class="color-09">折叠后</span>放入柜中</h3>
                <p class="f14 color-9 pt10">请关好门后点击完成，预收金额会原路退回</p>
            </div>
            <!--<div class="pt30">-->
                <!--<div class="content-box">-->
                    <!--<div class="flexJC alignItem fw">-->

                        <!--<ul class="flexJC-sb flex-wrap bedList">-->
                            <!--<li class="warp-item"-->
                                <!--v-for="(item,index) in bedList"-->
                                <!--:class="item.id == currentBed?'background-67':'background-f5'"-->
                            <!--&gt;{{item.id}}</li>-->
                        <!--</ul>-->
                        <!--<p v-show="currentBed>0">已开{{currentBed}}号门</p>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="pt20">-->
                <!--<div class="content-box">-->
                    <!--<div class="flexJC alignItem fw">-->
                        <!--<div class="f16 color-2">请将轮椅折叠后，箭头朝下的姿态</div>-->
                        <!--<div class="f16 color-2">放入柜中，并关闭柜门</div>-->
                        <!--<h3 class="f18 color-ff pt10">谢谢您的使用，期待再次为您服务</h3>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->

        </div>
        <div class="p15 flexJC alignItem mt36">
            <button class="btn-lx btn-lx-width btn-width mb20" v-show="isShow" @click="getOrder">刷新柜门</button>
            <button class="btn-lx btn-lx-width btn-width" @click="getFished()">完成</button>
            <!--<a href="tel:400-688-1003" class="btn-lx btn-lx-width">联系客服</a>-->
        </div>
        <!--弹框-->
        <div class="shade" v-show="isLoading">
            <div class="flexJC alignItem showLoading">
                <img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading"/>
            </div>
        </div>
        <!--广告弹框-->
        <div class="shade" v-show="isShowAdvert">
            <div class="upgrade-con">
                <div class="shade-close" @click="closeShade"></div>
                <div class="advert">
                    <a @click="goToNewUrl(outUrl)" class="displsy-block"><img :src="advertUrl" alt=""/></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import wxServ from '../service/wxServ'
    import cache from '../service/cacheServ'
    import userServ from '../service/userServ'
    import mintUi from '../lib/mint-ui'
    import cabinetServ from '../service/cabinetServ'
    var list = []
    for (var i=0;i<12; i++){
        list.push({
            id: i+1
        })
    }
    export default {
        data () {
            return {
                headPhoto: '/static/images/touxiang@2x.png',
                userName: '',
                isLoading: false,
                orderRefund: null,
                bedList:list,
                currentBed: null,
                isShow: false,
                bannerList:[],
                advertUrl: null,
                isShowAdvert: false,
                outUrl: null,
                cabinetInfo:null,
                orderInfo:null
            }
        },
        created () {
            this.getOrder()
//            this.getCabinetSta()
        },
        methods: {
            getOrder () {
                let customerWxId = cache.get('user').openId;
                let orderNo = this.$route.query.orderNo
                this.isLoading = true
                wxServ.getOrderRefund(customerWxId,orderNo).then(res => {
                    this.isLoading = false
                    if (res.code === '200') {
                        if(!res.data){
                           this.isShow = true
                        } else {
                            this.orderRefund = res.data
                            this.currentBed = parseInt(res.data.returnBedNo)
                            if(res.data.returnBedNo &&res.data.returnBedNo>0){
                                this.isShow = false
                            } else {
                                this.isShow = true
                            }
                        }
                    } else {
                        mintUi.Toast({
                            message: res.message,
                            position: 'bottom'
                        })
                    }
                })
            },
            goToUrl () {
                window.location.href ='http://www.aigehui028.com/'
            },
            getBannerList (position){
                this.isLoading = true
                wxServ.getBanner(position).then((res) => {
                    this.isLoading = false
                    if(res.code === '200'){
                        this.bannerList = res.data
                        if(res.data&&res.data.length>0){
                            this.advertUrl = res.data[0].advUrl
                            this.outUrl = res.data[0].outerUrl
                        }
                    }else {
                        mintUi.Toast({
                            message: res.message,
                            position: 'bottom'
                        })
                    }
                })
            },
            getFished(){
                this.isShowAdvert = true;
                this.stopScroll()
                this.getBannerList('AFTER')
            },
            bodyScroll(event) {
                event.preventDefault()
            },
            stopScroll () {
                document.body.style.overflow = 'hidden'
                document.addEventListener('touchmove', this.bodyScroll, false)
            },
            startScroll () {
                document.body.style.overflow = 'auto'// 出现滚动条
                document.removeEventListener('touchmove', this.bodyScroll, false)
            },
            closeShade(){
                this.isShowAdvert = false;
                this.startScroll()
            },
            goToNewUrl(url){
                if(url){
                    window.location.href = url
                } else {
                    return false
                }
            },
            filterFun: function (value) {
                if(value&& value.length > 13) {
                    value= value.substring(0,13)+ '...';
                }
                return value;
            },
            // 获取设备状态
            getCabinetSta (){
                let qrCode = this.$route.query.qrCode
//                this.isLoading = false
                cabinetServ.getCabinetStatus(qrCode).then(res =>{
//                    this.isLoading = true
                    if(res.code === '200'){
                        if(!res.data){

                        } else {
                            this.cabinetInfo = res.data
                            cache.set('cabinetInfo', res.data, true)
                        }
                    } else {
                        mintUi.Toast({
                            message: res.message,
                            position: 'bottom'
                        })
                    }
                })
            },
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
    @import '../less/_var.less';
    @import '../less/index.less';
    .index-banner{
        padding: 26px 25px 0 25px;
        text-align: left;
        color: #fff;
    }
    .pt5{
        padding-top: 5px;
    }
    .loadingImg{
        width: 100px;
        height: 100px;
    }
    .loading-con{
        width: 70%;
        margin-left: -35%;
    }
    .photo-icon{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        -webkit-border-radius: 50%;
    }
    .photo-icon img{
        width: 100%;
        height: 100%;
    }
    .userInfo{
        position: absolute;
        left: 90px;
        top:15px;
        right: 16px;
    }
    .icon_lb{
        background: url("../../static/images/icon_position.png") no-repeat;
        background-size: 100% 100%;
        width: 14px;
        height: 16px;
    }
    .icon-fy{
        background: url("../../static/images/icon_fy.png") no-repeat;
        background-size: 100% 100%;
        width: 22px;
        height: 22px;
    }
    .mt-3{
        margin-top: -3px;
    }
    .icon-sb{
        background: url("../../static/images/icon_sb.png") no-repeat;
        background-size: 100% 100%;
        width: 22px;
        height: 22px;
    }
    .icon_loading{
        width: 60px;
        height: 60px;
    }
    .warp-item{
        width: 12%;
        height: 50px;
        color: white;
        font-size: 16px;
        font-weight: bold;
        background: #c1c1c1;
        text-align: center;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 4px;
        -webkit-border-radius: 4px;
        display: flex;
        flex-direction: column;
    }
    .bedList>li:last-child,.bedList>li:nth-child(6){
        margin-right: 0;
    }
    .background-67{
        background-color: #67c23a;
    }
    .background-f5{
        background-color: #c1c1c1;
    }
    .icon-gh{
        width: 185px;
        height: 239px;
        position: relative;
        z-index: 2;
    }
    .icon-gh img{
        width: 100%;
        height: 100%;
    }
    .giveBack-jt{
        position: absolute;
        right: 30px;
        top:58px;
        width: 15px;
        z-index: 3;
    }
    .giveBack-jt p{
        line-height: 14.37px;
        margin-top: 5px;
    }
    .advert{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        border-radius: 10px;
    }
    .advert img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/giveBack-success.vue